import React from 'react'
import { t } from 'translation'
import LoadingButton from 'components/ui/LoadingButton/LoadingButton'
import { Link } from 'react-router-dom'

const INFO_LIST = [
  'INFO_LINE_1',
  'INFO_LINE_2',
  'INFO_LINE_3',
  'INFO_LINE_4',
  'INFO_LINE_5',
  'INFO_LINE_6',
  'INFO_LINE_7',
]

const SubscriptionStepOne = ({ currency, freeDays, price, setSubscriptionStep }) => {
  return (
    <div className="auth_block">
      <h1 className="section_title v4_mod color_mod offset_v4_mod">
        {t('subscription.FAST_RELIEF')}
      </h1>
      <ul className="auth_block_info_list offset_mod decor_mod">
        {INFO_LIST.map((item) => (
          <li key={item} className="auth_block_info_list_item">
            {t(`subscription.${item}`)}
          </li>
        ))}
      </ul>
      <div className={`auth_block_info ${Number(price) === 0 ? 'zero_price_mod' : ''}`}>
        <div
          className={`auth_block_info_heading ${
            Number(price) === 0 ? 'zero_price_mod' : ''
          }`}
        >
          {Number(price) > 0 ? (
            <div className="auth_block_info_title">
              <b>{t('signup.MONTHLY')}</b>
            </div>
          ) : null}
          <div className="auth_block_info_price">
            {currency === 'USD' ? '$' : null}
            {price}
            {currency === 'EUR' ? '€' : null} {t('subscription.PER_MONTH')}
          </div>
        </div>
        {/* {Number(price) > 0 && (
          <div className="auth_block_note limit_mod">
            {freeDays
              ? t('subscription.FREE_DAYS_AUTOMATIC_RENEWAL_DESCR')
              : t('subscription.AUTOMATIC_RENEWAL_DESCR')}
          </div>
        )} */}
      </div>
      <div className="btn_wrap center_lvl_mod">
        <LoadingButton
          onClick={() => setSubscriptionStep('two')}
          className="btn_base_v1 offset_mod"
          type="submit"
        >
          {t('subscription.CONTINUE')}
        </LoadingButton>
      </div>
    </div>
  )
}

export default SubscriptionStepOne
